// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"6427":"7607890b0b19554d49cd","8792":"29fa3e059edca8e77ebb"}[chunkId] + ".css";
};